var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15845 0.5C9.7407 0.5 11.2874 0.969192 12.603 1.84824C13.9186 2.72729 14.944 3.97672 15.5495 5.43853C16.155 6.90034 16.3134 8.50887 16.0047 10.0607C15.696 11.6126 14.9341 13.038 13.8153 14.1569C12.6965 15.2757 11.271 16.0376 9.71917 16.3463C8.16732 16.655 6.55879 16.4965 5.09698 15.891C3.63517 15.2855 2.38574 14.2602 1.50669 12.9446C0.627639 11.629 0.158447 10.0823 0.158447 8.5C0.158447 6.37827 1.0013 4.34344 2.50159 2.84315C4.00188 1.34285 6.03672 0.5 8.15845 0.5V0.5ZM8.07345 4.5H4.79845V7.095H3.65845V8.03H4.79845V9.03H3.65845V9.96H4.79845V12.5H8.07345C10.0434 12.5 11.5434 11.455 12.1184 9.935H13.1584V9H12.3484C12.3683 8.83407 12.3784 8.66711 12.3784 8.5C12.3777 8.35134 12.3694 8.20281 12.3534 8.055H13.1584V7.1H12.1584C11.5734 5.555 10.0634 4.5 8.07345 4.5ZM11.1134 9.935C10.8273 10.4856 10.3882 10.9418 9.84883 11.2488C9.3095 11.5557 8.69298 11.7002 8.07345 11.665H5.71345V9.935H11.1134ZM11.3984 8.03C11.4187 8.18584 11.4287 8.34285 11.4284 8.5C11.4302 8.66734 11.4185 8.83454 11.3934 9H5.71345V8L11.3984 8.03ZM8.07345 5.335C8.69782 5.30052 9.31873 5.4486 9.86035 5.76114C10.402 6.07368 10.8409 6.53716 11.1234 7.095H5.71345V5.335H8.07345Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.04b1085147418bca984f4051fb745a69.svg";
export { ForwardRef as ReactComponent };